/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * This event is dispatched whenever the graph changes due to edits.
 */
export class ChangeEvent extends Event {
    graph;
    version;
    visualOnly;
    changeType;
    affectedNodes;
    affectedModules;
    affectedGraphs;
    label;
    static eventName = "graphchange";
    constructor(graph, version, visualOnly, changeType, affectedNodes, affectedModules, affectedGraphs, label) {
        super(ChangeEvent.eventName, {
            bubbles: false,
            cancelable: true,
            composed: true,
        });
        this.graph = graph;
        this.version = version;
        this.visualOnly = visualOnly;
        this.changeType = changeType;
        this.affectedNodes = affectedNodes;
        this.affectedModules = affectedModules;
        this.affectedGraphs = affectedGraphs;
        this.label = label;
    }
}
/**
 * This event is dispatched whenever a proposed change to the graph is
 * rejected. The rejection may happen for two reasons
 * - error: the change would create an invalid graph. For instance, adding an edge to a non-existent node.
 * - nochange: the change is unnecessary, because it results in no actual change to the graph. For example, adding an edge that already exists.
 */
export class ChangeRejectEvent extends Event {
    graph;
    reason;
    static eventName = "graphchangereject";
    constructor(graph, reason) {
        super(ChangeRejectEvent.eventName, {
            bubbles: false,
            cancelable: true,
            composed: true,
        });
        this.graph = graph;
        this.reason = reason;
    }
}
//# sourceMappingURL=events.js.map